import request from '@/common/request'

class LeiService {
  getAll() {
    return request.get('/leis')
  }

  create(data) {
    return request.post('/leis', data)
  }

  update(id, data) {
    return request.patch(`/leis/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/leis/${id}`)
  }
}

export default new LeiService()
